const _excluded = ["identifier", "__isNew__"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { find, has, isArray, isObject } from 'underscore';
import PropTypes from 'prop-types';
import moment from 'moment';
import React from 'react';
import SinglePicker from '../../common/controls/singlePicker';
import { leafPedigreesString } from '../../../../behaviors/src/lib/common';
import { removeNulls } from '../../../utils/contentTools';
import localChangeSelector from '../selectors/localChangeSelector';

/**
 * Note that this is not a connected component. optionPickerField and componentCodePicker are both
 * connected and are the only code that create OptionSinglePicker
 */
/* eslint-disable no-underscore-dangle */
const OptionSinglePicker = ({
  allowsClear: _allowsClear = true,
  allowsOther: _allowsOther = false,
  className: inClassName = '',
  contentPath,
  enabled: _enabled = true,
  labelKey: _labelKey = 'title',
  onChange,
  options,
  path,
  placeholder: _placeholder = '',
  testingIdentifier: _testingIdentifier = '',
  value: _value = '',
  valueKey: _valueKey = 'identifier'
}) => {
  const localChangeFunc = localChangeSelector({}, {
    allowsClear: _allowsClear,
    allowsOther: _allowsOther,
    className: inClassName,
    contentPath,
    enabled: _enabled,
    labelKey: _labelKey,
    onChange,
    options,
    path,
    placeholder: _placeholder,
    testingIdentifier: _testingIdentifier,
    value: _value,
    valueKey: _valueKey
  });

  /**
   *  @function handleChange - transforms user selected data.
   */
  const handleChange = incomingValue => {
    if (incomingValue) {
      const {
          identifier,
          __isNew__
        } = incomingValue,
        rest = _objectWithoutProperties(incomingValue, _excluded);
      if (!rest._created) {
        rest._created = new Date().toISOString();
      }
      const v = {
        [identifier]: rest
      };
      const d = JSON.parse(JSON.stringify(v));
      const displayValue = leafPedigreesString(removeNulls(d));
      onChange(localChangeFunc({
        path,
        value: v,
        displayValue
      }));
    } else {
      onChange(localChangeFunc({
        path,
        value: null
      }));
    }
  };

  /**
   *  @function prepareValue - transforms data coming from server.
   */
  const prepareValue = () => {
    let transformedValue = '';
    let id = '';
    if (isArray(_value)) {
      transformedValue = '';
    }
    if (isObject(_value) && _value !== null && _value[Object.keys(_value)[0]] !== null) {
      const key = Object.keys(_value)[0];
      id = key;
      transformedValue = (_value[key] || {})[_labelKey];
    }
    return {
      value: transformedValue,
      id
    };
  };

  /**
   * @function prepareOptions - sorts options by _created field;
   *
   */
  const prepareOptions = () => {
    // check options array for existence of valueKey and labelKey fields.
    // if the valueKey field (ex. identifier) is missing,
    // create a valueKey field and assign it a value derived from labelKey.
    //
    // Also add a _created property to each option
    // based its order in the options array.
    const rawOptions = JSON.parse(JSON.stringify(options));
    const sortedOptions = [];

    // add value to options if it doesn't exist. this covers cases where a value is written by
    // a behavior and the options list is empty or does not contain the written value
    const optionsHasValue = opt => opt.identifier && _value[opt.identifier];
    if (_value && (rawOptions.length === 0 || !rawOptions.some(optionsHasValue))) {
      Object.keys(_value).forEach(key => {
        const data = _value[key];
        rawOptions.push(_objectSpread(_objectSpread({}, data), {}, {
          identifier: key
        }));
      });
    }
    rawOptions.forEach((option, index) => {
      let newOption = {};
      newOption = option;
      if (!has(newOption, '_created')) {
        newOption._created = index + 1;
      }
      if (!has(newOption, [_valueKey])) {
        newOption[_valueKey] = `_${newOption[_labelKey]}`;
      }
      sortedOptions.push(newOption);
    });
    return sortedOptions;
  };

  /**
   * @function prepareOtherOptions - adds an "other" value to the
   *                      options list so it may be shown as selected.
   */
  const prepareOtherOptions = () => {
    let optionsWithOther = prepareOptions();
    const prepared = prepareValue(_value);
    const otherValue = prepared.value;
    const {
      id
    } = prepared;
    // handles adding in "other" value to the options list
    const foundOption = find(optionsWithOther, option => option[_valueKey] === id);
    // include the value if it is NOT found in the option list.
    if (!foundOption && otherValue) {
      optionsWithOther = optionsWithOther.concat({
        [_valueKey]: id,
        [_labelKey]: otherValue,
        _created: moment().toISOString()
      });
    }
    return optionsWithOther;
  };
  let preparedOptions = [];
  let className = `${inClassName} `;
  if (_allowsOther) {
    preparedOptions = prepareOtherOptions();
    className += _testingIdentifier !== '' ? ` t-osp t-osp-${_testingIdentifier} ` : ' t-osp ';
  } else {
    preparedOptions = prepareOptions();
    className += _testingIdentifier !== '' ? ` t-osp t-osp-${_testingIdentifier} ` : ' t-osp ';
  }
  return /*#__PURE__*/React.createElement(SinglePicker, {
    className: className,
    labelKey: _labelKey,
    onChange: handleChange,
    options: preparedOptions,
    value: prepareValue().id,
    valueKey: _valueKey,
    returnValueKey: null,
    allowCreate: _allowsOther || false,
    disabled: !_enabled,
    verticalPadding: false,
    placeholder: _placeholder,
    clearable: _allowsClear
  });
};
OptionSinglePicker.propTypes = {
  allowsClear: PropTypes.bool,
  allowsOther: PropTypes.bool,
  className: PropTypes.string,
  contentPath: PropTypes.string.isRequired,
  enabled: PropTypes.bool,
  labelKey: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  path: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  testingIdentifier: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({}), PropTypes.array]),
  valueKey: PropTypes.string
};
export default OptionSinglePicker;